import actions from "./marketing-unsubscribe-actions";
import getters from "./marketing-unsubscribe-getters";
import mutations from "./marketing-unsubscribe-mutations";
import state from "./marketing-unsubscribe-state";
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default store;